import { isEqual } from "lodash";
import { useForm } from "react-hook-form";

import { DEFAULT_DISTANCE_IN_MILES_FILTER } from "../../ShiftDiscovery/Filters/constants";
import { DEFAULT_STORED_FILTERS } from "./constants";
import { type VisitFilters } from "./types";
import { useVisitFiltersContext } from "./useVisitFiltersContext";

function getDefaultFormValues(
  overrides: Partial<VisitFilters> & Pick<VisitFilters, "distance">
): VisitFilters {
  return {
    ...DEFAULT_STORED_FILTERS,
    ...overrides,
  };
}

export function useVisitFiltersForm() {
  const {
    setFilters,
    distance,
    shiftRoles,
    excludedCareTypes,
    visitTypes,
    payMinimum,
    visitsPerWeekMaximum,
  } = useVisitFiltersContext();

  const defaultFormValues = getDefaultFormValues({
    distance: DEFAULT_DISTANCE_IN_MILES_FILTER,
  });

  const form = useForm<VisitFilters>({
    defaultValues: {
      ...defaultFormValues,
      distance,
      shiftRoles,
      excludedCareTypes,
      visitTypes,
      payMinimum,
      visitsPerWeekMaximum,
    },
  });

  const formValues = form.watch();
  const changedFiltersCount = Object.entries(formValues).filter(
    ([key, value]) => !isEqual(value, defaultFormValues[key as keyof VisitFilters])
  ).length;

  const resetFilters = () => {
    const resetValues = getDefaultFormValues({ distance: DEFAULT_DISTANCE_IN_MILES_FILTER });
    form.reset(resetValues);
    setFilters(resetValues);
  };

  const cancelFilters = () => {
    form.reset({
      distance,
      shiftRoles,
      excludedCareTypes,
      visitTypes,
      payMinimum,
      visitsPerWeekMaximum,
    });
  };

  const submitFilters = () => {
    setFilters(formValues);
  };

  return {
    form,
    formValues,
    changedFiltersCount,
    resetFilters,
    cancelFilters,
    submitFilters,
  };
}
